export const hasVisibleReportColumns = (columns) => {
    if (!columns || Object.keys(columns).length === 0) return true;
    return Object.values(columns).some(column => column?.exportOnly !== true && column?.visible !== false);
};